import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import { withRouter } from "react-router-dom";

import UserRoles from "./roles";
import AddClientUser from "./add";
import SearchUser from "./search";
import AdminTable from "../../../shared/table";
import Modal from "../../../utils/customModal";
import StatusBill from "../../../shared/status";
import { moduleAction } from "../../../utils/functions";
import { getRoles } from "../../../../Redux/reducer/session";
import { MOD_CUSTOM, WRITE } from "../../../../permissions/";
import * as userActions from "../../../../Redux/actions/userActions";
import { errorContainer, loadingHtml } from "../../../utils/functions";
import { getInstitutionsProfile } from "../../../../Redux/reducer/clients";
import { getAllUsers, getTotalUsers } from "../../../../Redux/reducer/users";

import IconShow from "canvas-core-react/lib/IconShow";
import plusImage from "../../../../../static/images/plus.svg";
import NotificationIcon from "../../../../../static/images/notifications-hover.svg";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import { withTranslation } from "react-i18next";
import UserNotifications from "./userNotifications";
// import DeleteEdit from "../../../../../static/images/delete-action.svg";

export class ClientUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: true,
      search: false,
      addUser: false,
      notificationPage: false,
      editUser: false,
      roles: false,
      userCode: 0,
      user: null,
      editedUser: false,
      errorInSearch: false,
      navigation: { page: 0, size: 10 },
      modal: { loading: false, show: false, content: null },
      menus: [],
    };
  }

  componentDidMount() {
    const { page, size } = this.state.navigation;
    return this.updateUserList({ page, sizePerPage: size });
  }

  updateUserList = ({ page, sizePerPage }) => {
    const {
      client,
      actions: { getUsersByInstitution },
    } = this.props;

    var { list, search } = this.state;

    this.setState({
      modal: { loading: true, show: true, content: loadingHtml() },
    });
    var filter = [
      { property: "user.userType.id", operator: "not", value: "3" },
    ];

    return getUsersByInstitution(client.id, page, sizePerPage, filter).then(
      (response) => {
        if (response.totalElements <= 0) {
          list = false;
          search = true;
        } else {
          list = true;
          search = false;
        }

        this.setState({
          list,
          search,
          modal: { loading: false, show: false, content: null },
          navigation: { page, size: sizePerPage },
        });
      }
    );
  };

  componentWillUnmount() {
    this.props.actions.clearUsers();
  }

  updateUserCode = (userCode) => {
    this.setState({ userCode });
  };

  closeStep = () => {
    const { roles1, t } = this.props;

    var edit = moduleAction(roles1, MOD_CUSTOM, WRITE);

    const { buttonsText, modalMsg } = {
      buttonsText: t("general.buttons", { returnObjects: true }),
      modalMsg: t("clients.modal", { returnObjects: true }),
    };

    if (edit) {
      var buttons = {
        cancelBtn: {
          text: buttonsText.cancel,
          action: this.closeModal,
        },
        continueBtn: {
          text: buttonsText.continue,
          action: this.endStep,
        },
      };

      var content = errorContainer(
        modalMsg.managementCancelTitle,
        modalMsg.managementCancelDescription,
        buttons
      );
      this.setState({ modal: { loading: false, content, show: true } });
    } else {
      this.endStep();
    }
  };

  closeModal = () => {
    if (!this.state.modal.loading) {
      this.setState({ modal: { loading: false, show: false, content: null } });
    }
  };

  getContent = () => {
    return this.state.modal.loading ? (
      this.state.modal.content
    ) : (
      <div className="molda-setting-content">{this.state.modal.content}</div>
    );
  };

  endStep = () => {
    const { clearUserByCode } = this.props.actions;
    clearUserByCode();
    this.setState({
      list: true,
      search: false,
      addUser: false,
      notificationPage: false,
      editUser: false,
      roles: false,
      userCode: 0,
      user: null,
      editedUser: false,
      modal: { loading: false, show: false, content: null },
    });
    this.updateUserList({ page: 0, sizePerPage: 10 });
  };

  getTableColumns = () => {
    const { menus } = this.state;
    const { t } = this.props;

    return [
      {
        selector: "userCode",
        name: `${t("clients.users.table.headers.user_code")}`,
      },
      {
        selector: "name",
        name: `${t("clients.users.table.headers.user_name")}`,
      },
      {
        selector: "identification",
        name: `${t("clients.users.table.headers.identification")}`,
      },
      {
        selector: "status",
        name: `${t("clients.users.table.headers.state")}`,
      },
      {
        selector: "action",
        name: `${t("clients.users.table.headers.action")}`,
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[`menu-${row.id}`] || false}
            setIsMenuOpen={(open) => this.handleMenu(row.id, open)}
          >
            <ActionMenuListItem
              icon={() => <IconShow className="TextButton__icon--left" />}
              onClick={() => this.showUserInfo(row.id, row.codUser)}
            >
              {t("clients.users.table.headers.profile")}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  };

  handleMenu = (id, open) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = open;
    this.setState({ menus });
  };

  showUserInfo = (id, codUser) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = false;
    this.setState({ menus }, () => this.findUserByCode(codUser, true));
  };

  getData = () => {
    const { users } = this.props;

    return (
      users?.map(
        ({ codUser, lastName, firstName, identification, status, id }) => ({
          codUser: codUser,
          userCode: (
            <a
              className="lnk"
              onClick={() => this.findUserByCode(codUser, true)}
            >
              {codUser}
            </a>
          ),
          name: `${firstName} ${lastName}`,
          identification: identification,
          status: <StatusBill statusCode={status} />,
          id: `${id}-${identification}`,
        })
      ) || []
    );
  };

  findUserByCode = (userCode, editUser = false) => {
    this.setState({
      modal: { loading: true, show: true, content: loadingHtml() },
      menus: [],
    });
    const {
      client,
      actions: { getUserByCod },
      t,
    } = this.props;

    return getUserByCod(userCode, client.businessId, "CSA", client.country.code)
      .then((responseData) => {
        if (responseData.data.userIsRegistered === true && editUser === false) {
          this.setState({
            errorInSearch: true,
            modal: { loading: false, show: false, content: null },
          });
        } else {
          this.setState({
            list: false,
            search: false,
            addUser: true,
            notificationPage: false,
            editUser,
            errorInSearch: false,
            modal: { loading: false, show: false, content: null },
          });
        }
      })
      .catch(() => {
        // usuario no encontrado
        var buttons = {
          continueBtn: {
            text: t("general.buttons.continue"),
            action: this.endStep,
          },
        };
        var content = errorContainer(
          t("searchUser.modal.errorSearchTitle"),
          t("searchUser.modal.errorSearchDescription", { userCode }),
          buttons
        );
        this.setState({ modal: { loading: false, show: true, content } });
      });
  };

  handleNotifications = (value) => {
    this.setState({
      list: !value,
      search: false,
      addUser: false,
      notificationPage: value,
    });
  };

  render() {
    const {
      list,
      addUser,
      roles,
      search,
      userCode,
      editUser,
      editedUser,
      user,
      errorInSearch,
      navigation,
      notificationPage,
    } = this.state;
    const { roles1, totalElements, t } = this.props;

    var data = this.getData();
    var edit = moduleAction(roles1, MOD_CUSTOM, WRITE);

    return (
      <div id="client-user-admin">
        <ReactTitle title={`Gestión de Clientes - Usuarios`} />

        {list && (
          <React.Fragment>
            <div className="header-title flex-element">
              <div className="title gest-client flex-element">
                <div className="client-gest subtitle">
                  {t("clients.users.title")}
                </div>
              </div>
              {edit && (
                <div className="actions flex-element">
                  {data?.length > 0 && (
                    <a
                      className="add-button flex-element"
                      onClick={() => this.handleNotifications(true)}
                    >
                      <p className="bsc-add-client">
                        {t("clients.users.notificationsTab")}
                      </p>
                      <img src={NotificationIcon} />
                    </a>
                  )}

                  <a
                    className="add-button flex-element"
                    onClick={() => this.setState({ list: false, search: true })}
                  >
                    <p className="bsc-add-client">
                      {t("clients.users.add_user")}
                    </p>
                    <img src={plusImage} />
                  </a>
                </div>
              )}
            </div>
            <div className="client-list">
              <AdminTable
                headers={this.getTableColumns()}
                data={data}
                page={navigation.page}
                sizePerPage={navigation.size}
                totalSize={totalElements}
                onTableChange={this.updateUserList}
              />
            </div>
          </React.Fragment>
        )}
        {search && (
          <SearchUser
            findUserByCode={this.findUserByCode}
            errorInSearch={errorInSearch}
          />
        )}
        {addUser && (
          <AddClientUser
            canEdit={edit}
            isStatusSelect
            editUser={editUser}
            userCode={userCode}
            closeStep={this.closeStep}
            nextStep={(user, editedUser) =>
              this.setState({
                addUser: false,
                roles: true,
                user: user,
                editedUser: editedUser,
              })
            }
          />
        )}
        {roles && (
          <UserRoles
            canEdit={edit}
            editUser={editedUser}
            user={user}
            goBack={(user) =>
              this.setState({ addUser: true, roles: false, user: user })
            }
            endStep={this.endStep}
            closeStep={this.closeStep}
          />
        )}
        {notificationPage && (
          <UserNotifications
            {...this.props.client}
            goBack={() => this.handleNotifications(false)}
            handleUserDetail={this.findUserByCode}
          />
        )}
        <Modal
          handleClose={() => this.closeModal()}
          show={this.state.modal.show}
          id="add-user-modal"
        >
          {this.getContent()}
        </Modal>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles1: getRoles(state),
    client: getInstitutionsProfile(state),
    users: getAllUsers(state),
    totalElements: getTotalUsers(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(userActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(ClientUsers))
);
